<template>
  <div>
    <Hero />
    <Why />
    <FeaturedDorms />
    <PremiumDorms />
    <CityDorms />
    <Media />
    <!--<FixedPopup />-->
  </div>
</template>

<script>
import PremiumDorms from '@/components/Home/BlogSection.vue'
import CityDorms from '@/components/Home/CityDorms.vue'
import FeaturedDorms from '@/components/Home/FeaturedDorms.vue'
import Hero from '@/components/Home/Hero.vue'
import Media from '@/components/Home/Media.vue'
import Why from '@/components/Home/Why.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    Hero,
    Why,
    PremiumDorms,
    FeaturedDorms,
    CityDorms,
    Media
  },
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.settings ? this.settings.setting.title : '',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.settings ? this.settings.setting.description : ''
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.settings ? this.settings.setting.keywords : ''
        }
      ],
      link: [
        { rel: 'canonical', href: 'https://www.yurtlarburada.com' },
        { rel: 'favicon', href: 'favicon.ico' }
      ]
    }
  },
  computed: {
    ...mapGetters(['pageClass', 'showPreloader', 'showMenu', 'settings'])
  }
}
</script>

<style lang="scss"></style>
